import { useEffect } from 'react';

import { Fit, Layout, useStateMachineInput } from '@rive-app/react-canvas';

import { useRiveMachine } from '../../../hooks/rive/useRiveMachine';
import { ENVIRONMENT } from '../../../utils/environment';
import { getImageUrlWithBucketPrefix } from '../../../utils/images';

import classes from './ClaimDiceRiveAnimation.module.scss';

const STATE_MACHINE_NAME = 'State Machine 1';

interface ClaimDiceRiveAnimationProps {
  input: 'yellow' | 'green';
  onAnimationEnd?: () => void;
  amount: number;
}

const RIVE_ANIMATION_URL = getImageUrlWithBucketPrefix(`${ENVIRONMENT}/assets/rive/dice_collect.riv`);

export function ClaimDiceRiveAnimation(props: ClaimDiceRiveAnimationProps) {
  const { input, onAnimationEnd, amount } = props;

  const { rive, RiveComponent } = useRiveMachine({
    src: RIVE_ANIMATION_URL,
    stateMachineName: STATE_MACHINE_NAME,
    layout: new Layout({
      fit: Fit.Contain,
    }),
    onStateChange: (event) => {
      const data: string[] = event.data as string[];
      if (data && data.length && data[0] === 'animation_end') {
        if (onAnimationEnd) {
          onAnimationEnd();
        }
      }
    },
    autoplay: false,
  });

  const inputState = useStateMachineInput(rive, STATE_MACHINE_NAME, input, true);

  useEffect(() => {
    inputState?.fire();
    rive?.setTextRunValue('amount', `${amount}`);
    rive?.play();
  }, [amount, inputState, rive]);

  return (
    <div className={classes.container}>
      <RiveComponent />
    </div>
  );
}
